import { UpdateReleaseValidations } from 'types/releases';
import * as yup from 'yup';
import { fieldValidationMessages, formValidations } from 'app/constants';

export const getReleaseTitleFormValidations = (
  validations?: UpdateReleaseValidations
) => {
  const maxLength =
    validations?.title.maxLength || formValidations.MAX_TITLE_LENGTH;
  return yup.object().shape({
    title: yup
      .string()
      .required('')
      .max(maxLength, fieldValidationMessages.MAX_CHAR(maxLength)),
  });
};
